function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24 0A24 24 0 000 24a24 24 0 0024 24 24 24 0 0024-24A24 24 0 0024 0zm-2.8 12h5.6l-1 16.6h-3.63L21.2 12zm.12 19.37h5.33V36h-5.33v-4.63z",
  fillRule: "evenodd"
})));